import React, { useState, useEffect, useReducer } from "react";
import { Alert, Card, Col, Row, Modal, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import {
  FaBowlFood,
  FaCaretDown,
  FaCaretUp,
  FaChevronDown,
  FaChevronUp,
} from "react-icons/fa6";
import {
  calculateDefaultMealsCount,
  getDayName,
  getMealIdByFoodTime,
  isDatePassed,
  isToday,
  isTomorrow,
} from "../../../../../helpers/CommonHelper";
import { PiChefHat, PiCookingPotFill } from "react-icons/pi";
import { GrDeliver } from "react-icons/gr";
import axios from "../../../../../config/axios";
import {
  detailsInitialState,
  detailsReducer,
} from "../../../../../reducers/module/detailsReducer";
import { Store as toast } from "react-notifications-component";
import { toastNotification } from "../../../../../config/toastNotification";
const Item = ({ item, moduleConfig, data, tab, loadItems }) => {
  const [showPrintModal, setShowPrintModal] = useState(false);
  const [showPrintModal2, setShowPrintModal2] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false); // 👈 Accordion state
  const dayMeals = data.menuItems[item.date] || {};
  const [detailsState, detailsDispatch] = useReducer(
    detailsReducer,
    detailsInitialState
  );
  const handlePrintClick = () => setShowPrintModal(true);
  const handlePrintClick2 = () => setShowPrintModal2(true);
  const handleClose = () => setShowPrintModal(false);
  const handleClose2 = () => setShowPrintModal2(false);

  const downloadItem = async (data) => {
    detailsDispatch({
      type: "FETCH_REQUEST",
    });
    try {
      const res = await axios.post(
        `${moduleConfig.url}/download-for-kitchen`,
        data
      );
      detailsDispatch({
        type: "FETCH_SUCCESS",
        payload: res.data,
      });
    } catch (error) {
      detailsDispatch({
        type: "FETCH_FAILURE",
        payload: error,
      });
    }
  };
  const handleSelectDefault = async (a, b, c) => {
    try {
      const res = await axios.post(`${moduleConfig.url}/set-default-food`, {
        date: a,
        mealId: b,
        defaultFoodId: c,
      });
      if (res.status) {
        loadItems();
        toast.addNotification({
          ...toastNotification,
          title: "Success!",
          message: `Food selected as default meal.`,
          type: "success",
        });
      }
    } catch (error) {
      toast.addNotification({
        ...toastNotification,
        title: "Error!",
        message: `Default meal selection failed.`,
        type: "error",
      });
    }
  };
  const handleShowAlert = () => {
    toast.addNotification({
      ...toastNotification,
      title: "Error!",
      message: `Food already selected as default meal.`,
      type: "error",
    });
  };
  const downloadItemForDelivery = (data) => {
    axios
      .post(`${moduleConfig.url}/download-for-deliveries`, data)
      .then(function (response) {
        //console.log(response);

        let blob = new Blob([response.data], { type: "text/csv" }),
          downloadUrl = window.URL.createObjectURL(blob),
          filename = data?.date + "-delivery.csv";
        let a = document.createElement("a");
        if (typeof a.download === "undefined") {
          window.location.href = downloadUrl;
        } else {
          a.href = downloadUrl;
          a.download = filename;
          document.body.appendChild(a);
          a.click();
        }
      });
  };
  const handlePrint = () => {
    const modalContent = document.querySelector(".modal-content");

    const printWindow = window.open("", "", "width=800,height=600");
    // Get Bootstrap CSS from your app (if using CDN or imported in index.html)
    const bootstrapCSS = Array.from(
      document.querySelectorAll("link[rel='stylesheet']")
    )
      .map((link) => `<link rel="stylesheet" href="${link.href}">`)
      .join("");

    printWindow.document.write(`
      <html>
        <head>
          <title>Menu - ${item.date}</title>
  ${bootstrapCSS}
          <style>
                  @page { margin: 15mm; }
          body {
            background: #fff;
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
            margin: 0;
            padding: 15px;
            font-family: Arial;
          }
            img {margin-bottom:20px;}
          .modal-footer { display: none !important; }
           h3,h5 { margin: 0px; }
            h3 { margin-bottom: 20px; }
           h5 { margin-bottom: 20px;  color: #444;}
          ul { padding-left: 20px; }
          li { margin-bottom: 4px; }
          </style>
        </head>
        <body>${modalContent.innerHTML}</body>
      </html>
    `);
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
    printWindow.close();
  };
  const handlePrint2 = () => {
    const modalContent = document.querySelector(".modal-content");

    const printWindow = window.open("", "", "width=800,height=600");

    // Get Bootstrap CSS from your app (if using CDN or imported in index.html)
    const bootstrapCSS = Array.from(
      document.querySelectorAll("link[rel='stylesheet']")
    )
      .map((link) => `<link rel="stylesheet" href="${link.href}">`)
      .join("");

    printWindow.document.write(`
    <html>
      <head>
        <title>Menu For Kitchen - ${item.date}</title>
        ${bootstrapCSS}
        <style>
          @page { margin: 15mm; }
          body {
            background: #fff;
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
            margin: 0;
            padding: 15px;
            font-family: Arial;
          }
          .modal-footer { display: none !important; }
          h3, h5 { margin: 0; }
          ul { padding-left: 20px; }
          li { margin-bottom: 4px; }
        </style>
      </head>
      <body>${modalContent.innerHTML}</body>
    </html>
  `);

    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
    printWindow.close();
  };
  const pastDay = isDatePassed(item.date);

  return (
    <>
      <Card className="item mb-2 borderCream">
        {/* HEADER */}
        <Card.Header
          className={`ps-1 pe-2 py-0 d-flex align-items-center justify-center-between ${
            pastDay ? "cursor-pointer" : ""
          }`}
          onClick={() => pastDay && setIsExpanded((prev) => !prev)} // 👈 toggle accordion
        >
          <Card.Title
            className="d-flex  p-0 ms-1  align-items-center"
            style={{ flex: 1 }}
          >
            <div className="d-flex ImageSectionSpacing align-items-center">
              <FaBowlFood
                style={{ fontSize: "28px" }}
                className="fa fa-cutlery me-3 text-secondary"
              />
              <div className="d-flex flex-column">
                <span className="m-0 fw-bold text-red">{item.date}</span>
                <span className="text-custom-4 small">
                  {getDayName(item.date)}
                </span>
              </div>
            </div>
          </Card.Title>
          <div className="text-end card-tools me-1">
            {pastDay && (
              <span
                className={`badge fw-semibold badge-dark rounded-pill shadow-sm me-3 px-2`}
              >
                Past Day
              </span>
            )}

            <Link
              to={`/menu/${item.date}`}
              className="btn btn-outline-secondary listingActionIcon"
              title={`View ${moduleConfig.singleItemTitle}`}
              onClick={(e) => e.stopPropagation()} // prevent accordion toggle
            >
              <i className="fas fa-eye"></i>
            </Link>

            {/* <span
              className="btn btn-outline-secondary listingActionIcon"
              title={`Print ${moduleConfig.singleItemTitle}`}
              onClick={(e) => {
                e.stopPropagation(); // prevent toggle
                handlePrintClick();
              }}
            >
              <i className="fa fa-print"></i>
            </span> */}
            <span
              className="btn btn-outline-secondary listingActionIcon"
              title={`Download menu for kitchen`}
              onClick={(e) => {
                e.stopPropagation(); // prevent toggle
                downloadItem({ date: item.date });
                handlePrintClick2();
              }}
            >
              <PiCookingPotFill />
            </span>
            <span
              className="btn btn-outline-secondary listingActionIcon"
              title={`Download menu for delivery`}
              onClick={(e) => {
                e.stopPropagation(); // prevent toggle
                downloadItemForDelivery({ date: item.date });
              }}
            >
              <GrDeliver />
            </span>
            {pastDay && (
              <span className="ms-2 text-muted small">
                {isExpanded ? "▲" : "▼"}
              </span>
            )}
          </div>
        </Card.Header>

        {/* BODY — show only if not past OR if expanded */}
        {(!pastDay || isExpanded) && (
          <Card className="mb-0 shadow-sm border-0">
            <Card.Body className="px-2 py-2 mb-0">
              <Row>
                {data.meals.map((meal) => {
                  const foods = dayMeals[meal.title] || [];
                  const defaultFood = dayMeals["defaultFood"] || [];
                  const defaultSelectedFood = defaultFood[meal?.title];
                  const count = foods.length;

                  const bgColor = pastDay
                    ? "#eee"
                    : count < 1
                    ? "#ffecec"
                    : count < 2
                    ? "#fff8cc"
                    : "#e6f8e6";

                  const borderColor =
                    count < 1 ? "#ffc2c2" : count < 2 ? "#ffed80" : "#a4e2a0";

                  const showButton = count < 2;
                  const buttonLabel =
                    count < 1 ? "Select Meals" : "Select More";
                  const buttonBg = count < 1 ? "#ff9999" : "#ffe680";
                  const buttonHover = count < 1 ? "#ff7a7a" : "#ffdb4d";

                  return (
                    <Col key={meal._id} md={3} sm={6} xs={12} className="mb-3">
                      <div
                        className="border rounded h-100 shadow-sm d-flex flex-column justify-content-between"
                        style={{
                          backgroundColor: bgColor,
                          borderColor,
                          color: "#2A1008",
                          transition:
                            "background-color 0.3s ease, border-color 0.3s ease",
                        }}
                      >
                        <h6
                          className="fw-bold py-1 px-2 mb-2 mt-0 text-center rounded-top"
                          style={{ backgroundColor: "rgba(0,0,0,0.05)" }}
                        >
                          {meal.title}{" "}
                          <span className="font-small">({count} selected)</span>
                        </h6>

                        <ol className="px-3 mb-2">
                          {foods.length > 0 ? (
                            foods.map((food) => {
                              const isDefault =
                                defaultSelectedFood?._id === food?._id;
                              const noDefault = !defaultSelectedFood; // <-- key condition

                              return (
                                <li
                                  key={food._id}
                                  className={`small mb-1 fst-italic d-flex align-items-center justify-content-start text-center food-item ${
                                    !pastDay &&
                                    !isToday(item.date) &&
                                    !isTomorrow(item.date)
                                      ? "cursor-pointer"
                                      : "cursor-normal"
                                  } ${isDefault ? "always-show-radio" : ""}`}
                                  style={{ fontSize: "15px" }}
                                >
                                  {!pastDay &&
                                    !isToday(item.date) &&
                                    !isTomorrow(item.date) && (
                                      <input
                                        type="radio"
                                        title="Click to set food as default food"
                                        className="me-2 food-radio"
                                        checked={isDefault}
                                        onChange={
                                          isDefault
                                            ? () => handleShowAlert()
                                            : () =>
                                                handleSelectDefault(
                                                  item.date,
                                                  meal?._id,
                                                  food._id
                                                )
                                        }
                                        style={{ cursor: "pointer" }}
                                      />
                                    )}

                                  <span
                                    className="me-1 text-truncate"
                                    style={{
                                      maxWidth: "78%",
                                      display: "block",
                                    }}
                                  >
                                    {food.title}
                                  </span>

                                  {food.vegOrNonVeg === "Veg" ? (
                                    <span className="text-success small fst-normal">
                                      ( Veg )
                                    </span>
                                  ) : (
                                    <span className="text-danger small fst-normal">
                                      ( Non )
                                    </span>
                                  )}
                                </li>
                              );
                            })
                          ) : (
                            <li
                              style={{ fontSize: "15px" }}
                              className="small fst-italic text-center text-muted"
                            >
                              No items
                            </li>
                          )}
                        </ol>

                        {!pastDay &&
                          !isToday(item.date) &&
                          !isTomorrow(item.date) && (
                            <div className="text-center pb-2">
                              <Link
                                to={`/menu/update/${getMealIdByFoodTime(
                                  data?.meals,
                                  meal?.title
                                )}/${item.date}`}
                                className="btn btn-sm border-0 px-3 py-1 fw-semibold"
                                title={`Update ${moduleConfig.singleItemTitle}`}
                                style={{
                                  backgroundColor: showButton
                                    ? buttonBg
                                    : "#baf5b2",
                                  color: "#2A1008",
                                }}
                                onMouseEnter={(e) =>
                                  (e.target.style.backgroundColor = showButton
                                    ? buttonHover
                                    : "#9ae78a")
                                }
                                onMouseLeave={(e) =>
                                  (e.target.style.backgroundColor = showButton
                                    ? buttonBg
                                    : "#baf5b2")
                                }
                              >
                                {showButton ? buttonLabel : "Update"}
                              </Link>
                            </div>
                          )}
                        {(pastDay ||
                          isToday(item.date) ||
                          isTomorrow(item.date)) && (
                          <div className="text-center pb-2"></div>
                        )}
                      </div>
                    </Col>
                  );
                })}
              </Row>
            </Card.Body>
          </Card>
        )}
      </Card>

      <Modal show={showPrintModal2} onHide={handleClose2} size="lg" centered>
        <Modal.Body>
          {
            <div style={{ padding: "15px" }}>
              {/* Meal Stats & Menu */}
              <Row>
                <Col xl={"auto"} className="mb-2">
                  <h1 className="text-bold">Nutricub - Kitchen Plan</h1>
                </Col>

                {/* Date and Day - centered below image */}
                <Col xs={12} className="text-left mb-3">
                  <h3
                    className="fw-bold mb-1 text-left"
                    style={{
                      color: "#000",
                      letterSpacing: "1px",
                      fontSize: "18px",
                      margin: 0,
                    }}
                  >
                    {item.date}{" "}
                    <span
                      className="text-muted mb-2 text-left"
                      style={{
                        color: "#000",
                        letterSpacing: "1px",
                        fontSize: "15px",
                      }}
                    >
                      ({getDayName(item.date)})
                    </span>
                  </h3>
                </Col>

                <Col md={12}>
                  {detailsState?.data?.stats?.length === 0 && (
                    <p className="text-dark py-1 rounded text-center alert-custom-2 mt-3 fw-semibold">
                      No subscriptions available for this day.
                    </p>
                  )}
                  {detailsState?.data?.stats?.length > 0 &&
                    detailsState.data.stats.map((mealStat) => {
                      const mealTitle = mealStat?.title;
                      const mealItems =
                        detailsState?.data?.menuItems?.[mealTitle] &&
                        Array.isArray(detailsState.data.menuItems[mealTitle])
                          ? detailsState.data.menuItems[mealTitle]
                          : [];

                      return (
                        <div key={mealStat?._id} className="mb-4 text-left">
                          {/* Meal Title */}
                          <div className="d-flex align-items-center mb-2">
                            <h5
                              className="fw-bold mb-0"
                              style={{
                                color: "#000",
                                borderBottom: "1px dashed #ccc",
                                width: "fit-content",
                                marginRight: "10px",
                              }}
                            >
                              {mealTitle}
                            </h5>
                            <span
                              className="text-muted"
                              style={{ fontSize: "14px" }}
                            >
                              (Total Subscriptions:{" "}
                              {mealStat?.totalSubscriptions ?? 0})
                            </span>
                          </div>

                          {/* Food Items */}
                          <ul
                            className="list-unstyled mb-0 mt-2"
                            style={{
                              lineHeight: "1.8",
                              fontSize: "15px",
                              color: "#333",
                            }}
                          >
                            {mealItems.length > 0 &&
                              mealItems.map((food) => (
                                <li
                                  key={food?._id}
                                  className="fw-semibold"
                                  style={{
                                    fontSize: "15px",
                                    color: "#444",
                                  }}
                                >
                                  {food?.title}{" "}
                                  <span
                                    style={{
                                      color: "#666",
                                      fontSize: "14px",
                                      fontWeight: "400",
                                    }}
                                  >
                                    ({food?.selectedByCustomers ?? 0})
                                  </span>
                                </li>
                              ))}
                            {calculateDefaultMealsCount(
                              detailsState.data,
                              mealStat?._id
                            ) > 0 && (
                              <li
                                className="fw-semibold"
                                style={{
                                  fontSize: "15px",
                                  color: "#444",
                                }}
                              >
                                Default Meal
                                <span
                                  style={{
                                    color: "#666",
                                    fontSize: "14px",
                                    fontWeight: "400",
                                  }}
                                >
                                  (
                                  {calculateDefaultMealsCount(
                                    detailsState.data,
                                    mealStat?._id
                                  )}
                                  )
                                </span>
                              </li>
                            )}
                          </ul>
                        </div>
                      );
                    })}
                </Col>
              </Row>
            </div>
          }
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose2}>
            Close
          </Button>
          {detailsState?.data?.stats?.length > 0 && (
            <Button variant="primary" onClick={handlePrint2}>
              Print
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Item;
